export default {
    designations: [],
    designation:{},
};